import React from "react";
import { Box, Grid, Stack, Typography, Avatar } from "@mui/material";
import { getFundInitial } from "../../utils/getLogoUrl";

const statusColors = {
  SELL: "#ef4444",
  HOLD: "#f59e0b",
  BUY: "#10b981",
  ACTIVE: "#22c55e",
  INACTIVE: "#ef4444",
  PENDING: "#f59e0b",
};

const FinFactorFundCard = ({
  status,
  logo,
  name,
  folio,
  type,
  isExternal,
  fields = [],
  isDynamicGridSize = false,
}) => {
  console.log({ fields });
  return (
    <Box sx={{ position: "relative", mb: 2 }}>
      {/* STATUS BADGE */}

      <Box
        sx={{
          position: "absolute",
          top: -1,
          left: 0,
          bgcolor: statusColors[status] || "#64748B",
          color: status === "HOLD" ? "black" : "white",
          px: 3,
          py: 0.5,
          borderRadius: "8px 0 8px 0",
          fontSize: "12px",
          fontWeight: "700",
          zIndex: 1,
        }}
      >
        {status}
      </Box>

      {/* CARD */}

      <Box
        sx={{
          backgroundColor: "#13172a",
          borderRadius: "12px",
          p: { xs: 2.5, md: 3 },
          pt: { xs: 3.5, md: 4 },
          border: "1px solid rgba(255,255,255,0.08)",

          // "&:hover": {
          //     borderColor: "rgba(255,255,255,0.15)",
          //     backgroundColor: "#1c2033"
          // }
        }}
      >
        <Grid container spacing={2} alignItems="center">
          {/* LEFT INFO */}

          <Grid item xs={12} md={5}>
            <Stack
              direction="row"
              mt={0.7}
              alignItems="center"
              sx={{
                flexWrap: "wrap",
                gap: "6px",
              }}
            >
              <Avatar
                src={logo}
                variant="rounded"
                sx={{
                  width: 44,
                  height: 44,
                  bgcolor: "white",
                  p: 0.5,
                  color: "#1B1F3B",
                  fontWeight: 700,
                }}
              >
                {getFundInitial({ name })}
              </Avatar>

              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: "white",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  {name}
                </Typography>

                <Stack
                  direction="row"
                  mt={0.7}
                  alignItems="center"
                  sx={{
                    flexWrap: "wrap",
                    gap: "8px",
                  }}
                >
                  {/* FOLIO */}
                  <Typography
                    sx={{
                      fontSize: { xs: "11px", md: "12px" },
                      color: "rgba(255,255,255,0.4)",
                      minWidth: { xs: "auto", md: "70px" },
                    }}
                  >
                    {folio}
                  </Typography>

                  {/* SIP */}
                  {type && (
                    <Box
                      sx={{
                        bgcolor: "rgba(255,255,255,0.08)",
                        px: 1,
                        py: 0.3,
                        borderRadius: "4px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: 600,
                          color: "white",
                        }}
                      >
                        {type}
                      </Typography>
                    </Box>
                  )}

                  {/* EXTERNAL */}
                  {isExternal && (
                    <Box
                      sx={{
                        bgcolor: "rgba(255,255,255,0.1)",
                        px: 1,
                        py: 0.3,
                        borderRadius: "4px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "10px",
                          fontWeight: 600,
                          color: "white",
                        }}
                      >
                        External Fund
                      </Typography>
                    </Box>
                  )}
                </Stack>
              </Box>
            </Stack>
          </Grid>

          {/* DYNAMIC FIELDS */}

          <Grid item xs={12} md={7}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                flexWrap: "wrap",
                gap: { xs: 1.25, sm: 1 },
                justifyContent: "space-between",
                mt: { xs: 1, sm: 0 }
              }}
            >
              {fields.map((field, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: { xs: "1 1 100%", sm: 1 },
                    minWidth: { xs: "100%", sm: "auto" },
                    display: { xs: "flex", md: "block" },
                    flexDirection: { xs: "row", md: "column" },
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: {
                      xs: "left",
                      md: (fields.length === 3 && index === 1) ? "center" : (index === fields.length - 1 ? "right" : "left"),
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "11px", md: "12px" },
                      color: "rgba(255,255,255,0.4)",
                      mb: { md: 0.5 }
                    }}
                  >
                    {field.label}
                  </Typography>

                  <Box sx={{ textAlign: "inherit" }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: field.color || "white",
                        fontSize: { xs: "13px", md: "1rem" },
                        lineHeight: 1
                      }}
                    >
                      {field.value}
                    </Typography>

                    {field.subValue && (
                      <Typography
                        sx={{
                          fontSize: { xs: "11px", md: "12px" },
                          fontWeight: 600,
                          color: field.subColor || "#10B981",
                        }}
                      >
                        {field.subValue}
                      </Typography>
                    )}
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FinFactorFundCard;
